import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {Decadence} from "../Decadence";
import {DecadenceGameAssets} from "../DecadenceGameAssets";
import {GameMode} from "@nolimitcity/slot-game/bin/flowcontrol/GameMode";
import {SpineGSAPWrapper} from "../animation/SpineGSAPWrapper";
import {gsap} from "gsap"
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {DecadenceStatics} from "../config/DecadenceStatics";

export class SkateOrDieBackgroundElements extends PIXI.Container implements StageLayer {

    private currentMode:GameMode = GameMode.NORMAL;

    private bgAnimation:PIXI.spine.Spine;

    constructor() {
        super();
        this.name = "BackgroundElements";

        this.bgAnimation = DecadenceGameAssets.createSpine(DecadenceGameAssets.BG_ANIMATION);
        this.bgAnimation.position.set(360, 360);
        this.bgAnimation.state.setAnimation(0, "idle", true);
        this.addChild(this.bgAnimation);
        this.onResize();
    }

    public setMode(mode:GameMode):void {
        if(mode == this.currentMode) return;

        switch (mode) {
            case GameMode.NORMAL:
                Decadence.soundPlayer.stopSound("thunder");
                this.bgAnimation.state.setAnimation(0, "idle", true);
                break;

            case GameMode.FREESPIN_SUPER:
            case GameMode.FREESPIN:
                Decadence.soundPlayer.playLoopingSound("thunder");
                this.bgAnimation.state.setAnimation(0, "fs_idle", true);
                break;

            default:
                break;
        }
        this.currentMode = mode;
    }

    public transitionMode(newMode:GameMode):gsap.core.Timeline {
        const tl = gsap.timeline();
        if(newMode == this.currentMode) return tl;
        switch (newMode) {
            case GameMode.FREESPIN_SUPER:
            case GameMode.FREESPIN:
                tl.add(() => {
                    Decadence.soundPlayer.playLoopingSound("thunder");
                })
                tl.add(SpineGSAPWrapper.createTimeline(this.bgAnimation, 0, "fs_intro"));
                tl.add(() => {
                    this.bgAnimation.state.setAnimation(0, "fs_idle", true);
                })
                break;

            case GameMode.NORMAL:
                tl.add(SpineGSAPWrapper.createTimeline(this.bgAnimation, 0, "fs_outro"))
                tl.add(() => {
                    Decadence.soundPlayer.stopSound("thunder", 500);
                    this.bgAnimation.state.setAnimation(0, "idle", true);
                })
                break;
        }
        this.currentMode = newMode;
        return tl;
    }

    public onRestore():void {
       if(Decadence.model.isFreeSpins || Decadence.model.triggeredFreeSpins) {
           this.setMode(GameMode.FREESPIN);
       }
    }

    onResize() {
        const isPortrait = !NolimitApplication.isLandscape;
        if(isPortrait) {
            this.position.y = DecadenceStatics.GAME_ELEMENTS_PORTRAIT_OFFSET;
        } else {
            this.position.y = 0;
        }
    }
}